import projectDetailFragment from './Fragments/projectDetailFragment'

const removeProjectFromGarageQuery = /* GraphQL */ `
  mutation RemoveProjectFromGarage($projectToRemove: ProjectRemoveRequestInput = null) {
    removeProjectFromGarage(projectToRemove: $projectToRemove) {
      success
      projects {
        ...ProjectDetailFragment
      }
      message
    }
  }
  ${projectDetailFragment}
`

export default removeProjectFromGarageQuery
